import colors from '@theme/colors';
import { scale, verticalScale } from '@utils/normalize';
import { StyleSheet } from 'react-native';

const styles = StyleSheet.create({
  bottomView: {
    alignSelf: 'stretch',
    borderBottomLeftRadius: 0,
    borderBottomRightRadius: 0,
    marginHorizontal: 0,
    marginTop: 0,
    paddingTop: verticalScale(10),
  },
  container: { flex: 1 },
  okButton: { marginBottom: 0, paddingVertical: scale(8) },
  promoSection: { paddingBottom: verticalScale(6), paddingTop: verticalScale(16) },
  scrollBody: { flexGrow: 1, justifyContent: 'space-between' },
  scrollContentContainer: {
    flexGrow: 1,
    paddingBottom: verticalScale(12),
    paddingHorizontal: scale(16),
  },
  scrollView: { flex: 1 },
  successInfo: {
    alignItems: 'center',
    alignSelf: 'stretch',
    backgroundColor: colors.secondary.softOrchid,
    borderRadius: 8,
    flexDirection: 'row',
    marginTop: verticalScale(37),
    paddingHorizontal: scale(12),
    paddingVertical: verticalScale(8),
  },
  successParent: { alignItems: 'center', marginTop: verticalScale(24) },
  txnBannerStyle: { marginBottom: 0, marginHorizontal: 0, marginTop: verticalScale(12) },
});
export default styles;
